export function getOrgWithExceededLimit(orgTree, selectedOrganizations, prevSelectedOrganizationIds) {
    var _a;
    if (!orgTree.length || !selectedOrganizations.total) {
        return undefined;
    }
    // Use a Map to aggregate exceeded children across roots to avoid duplicates
    const exceededChildrenMap = new Map();
    for (const root of orgTree) {
        const max = root.maxNumberOfMembershipsPerOrgTree;
        if (!max || max < 1) {
            continue; // no limit configured for this root
        }
        const selectedDescendantMap = new Map();
        for (const org of selectedOrganizations.rows) {
            if ((_a = org.columns.path) === null || _a === void 0 ? void 0 : _a.startsWith(`${root.path}/`)) {
                selectedDescendantMap.set(org.id, org.columns.name);
            }
        }
        if (selectedDescendantMap.size > max) {
            for (const [k, v] of selectedDescendantMap) {
                if (!prevSelectedOrganizationIds.includes(k)) {
                    exceededChildrenMap.set(k, v);
                }
            }
        }
    }
    if (exceededChildrenMap.size === 0) {
        return undefined;
    }
    return exceededChildrenMap;
}
